import React, { Component } from "react";
import MenuButton from "./MenuButton";
import "../styles/Menu.css";

class Menu extends Component {
  render() {
    return (
      <div className="menu bg-gray">
        <MenuButton destination="location">
          1. Location
        </MenuButton>
        <MenuButton destination="target">
          2. Target
        </MenuButton>
        <MenuButton destination="age">
          3. Age Range
        </MenuButton>
        <MenuButton destination="results">
          4. Results
        </MenuButton>
      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js